/* eslint-disable parog-web/no-glint-expect-error-directive */
import type { TOC } from '@ember/component/template-only';
import formatNumber from 'ember-intl/helpers/format-number';
import eq from 'ember-truth-helpers/helpers/eq';
import JesHistoryTable from 'parog-web/components/jes-history-table';
import ValueWithUnit from 'parog-web/components/value-with-unit';
import PageContainer from 'ui-kit/components/page-container';
interface Signature {
  Args: {
    patient?: unknown;
  };
}

const MeasurementsResults: TOC<Signature> = <template>
  <PageContainer @title='Historique des mensurations'>
    <:content>

      {{! @glint-expect-error }}
      <JesHistoryTable class='unstackable striped' @patient={{@patient}}>
        <:columns as |Column|>
          <Column
            @modelName='weight-measured-journal-event'
            @feature='measurements'
            @component='weight-edition-form'
          >
            <:label>Poids</:label>
            <:value as |je|>
              <ValueWithUnit @value={{formatNumber je.weight}} @unit='kg' />
              {{#if (eq je.source 'withings')}}
                <i class='wifi icon'></i>
              {{/if}}
            </:value>
          </Column>

          <Column
            @modelName='height-measured-journal-event'
            @feature='measurements'
            @component='height-edition-form'
          >
            <:label>Taille</:label>
            <:value as |je|>
              <ValueWithUnit @value={{formatNumber je.height}} @unit='cm' />
            </:value>
          </Column>

          <Column
            @modelName='weight-measured-journal-event'
            @shouldHideArchiveButtons={{true}}
            @hideEditLinks={{true}}
          >
            <:label>IMC</:label>
            <:value as |je|>{{if je.bmi je.bmi '-'}}</:value>
          </Column>

          {{! @glint-expect-error }}
          {{#if (eq @patient.therapeuticalArea.id 'mental')}}
            <Column
              @modelName='abdominal-area-declared-journal-event'
              @feature='abdominal-area'
              @component='edition-form'
            >
              <:label>Périmètre abdominal</:label>
              <:value as |je|>
                <ValueWithUnit @value={{je.value}} @unit='cm' />
              </:value>
            </Column>
          {{/if}}

        </:columns>
        <:noData>Aucune mesure de poids pour ce patient</:noData>
      </JesHistoryTable>
    </:content>
  </PageContainer>
</template>;
export default MeasurementsResults;
